<template>
  <div class="v2026-statusrows" v-if="rows.length">
    <div class="v2026-statusrows__row" v-for="row in rows" :key="row.key || row.label">
      <span class="v2026-statusrows__label">{{ row.label }}</span>
      <!-- html rows carry the global filter's badge markup; sanitisation stays upstream. -->
      <span v-if="row.html" class="v2026-statusrows__value" v-html="row.html"></span>
      <span v-else class="v2026-statusrows__value">
        <span v-if="row.dot" class="v2026-statusrows__dot" :class="'is-' + row.dot"
              aria-hidden="true"></span>
        {{ row.text }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'panel-status-rows-v2026',
  props: {
    // [{ key?, label, html? | text?, dot?: 'online' | 'offline' | null }]
    // `html` wins over `text`; `dot` is ignored on an html row.
    rows: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.v2026-statusrows {
  --v2026-statusrows-surface-sunken: #F8FAFC;
  --v2026-statusrows-text: #101828;
  --v2026-statusrows-text-secondary: #667085;
  --v2026-statusrows-text-muted: #98a2b3;

  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 16px;
}

.v2026-statusrows__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  background: var(--v2026-statusrows-surface-sunken);
  border-radius: 12px;
}

.v2026-statusrows__label {
  font-size: 13px;
  font-weight: 600;
  color: var(--v2026-statusrows-text-secondary);
}

.v2026-statusrows__value {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--v2026-statusrows-text);
}

.v2026-statusrows__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: 0 0 auto;
}
.v2026-statusrows__dot.is-online {
  background: #12b76a;
}
.v2026-statusrows__dot.is-offline {
  background: var(--v2026-statusrows-text-muted);
}
</style>
